import React from "react";

export default function NoMatch() {
  return (
    <div>
      <h1>Route not found</h1>
    </div>
  );
}
